// @flow
import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import EmptyNews from '../../../../assets/images/empty-news.jpg';

type Props = {
  value?: string
};


const EmptyNewsBanner = ({ value }: Props) => (
  <div className='swiper-slide'>
    <div className='banner-content'>
      <div className='banner-image' style={{ backgroundImage: `url("${encodeURI(EmptyNews)}")` }} />
      <div className='banner-news banner-news--empty ui-site-description'>
        <div className='banner-news__blur' style={{ backgroundImage: `url("${encodeURI(EmptyNews)}")` }} />
        <p className='news-text news-text--empty'>
          {value
            ? (
              <FormattedHTMLMessage id='nav_block.news.banner.empty_news_text' />
            ) : (
              <FormattedMessage id='nav_block.news.banner.null_news_text' />
            )}
        </p>
      </div>
    </div>
  </div>
);

export default EmptyNewsBanner;
